import {Component, Input, OnInit} from '@angular/core';
import {EnvService} from "../../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {ActivatedRoute, Router, Params} from '@angular/router';
import {AlertService} from "../../services/alert.service";
import {AuthService} from "../../services/auth.service";

@Component({
  selector: 'micro-itsm-changeDetail',
  templateUrl: './itsm-changeDetail.component.html'
})
export class ItsmChangeDetailComponent implements OnInit {

  @Input()
  itsmCarrierId:any;

  @Input()
  changeId:any;
  change:any;

  constructor(protected env: EnvService,
              protected http: HttpClient,
              private route: ActivatedRoute,
              private router:Router,
              private authService:AuthService,
              private alertService:AlertService) {
  }

  ngOnInit() {
    let params: HttpParams = new HttpParams()
      .set('itsmCarrierId', this.itsmCarrierId)
    ;

    this.http.get(`${this.env.e.url}/task/itsm/changes/${this.changeId}`, {params: params}).subscribe(
      data => {
        this.change = data as any;
      }
    );
  }
}
